import { useNavigate } from "react-router-dom";

export const Gallery = () => {
  const navigate = useNavigate();

  const categories = [
    { title: "Flour", image: "/img/flours.jpg", link: "/otifoods", brand: "Flour" },
    { title: "Pasta", image: "/img/pastas.jpg", link: "/otifoods", brand: "Pasta" },
    { title: "Oil", image: "/img/oils.jpg", link: "/otifoods" , brand: "Oil"},
    { title: "Confectionery", image: "/img/cookie.jpg", link: "/otifoods" , brand: "Confectionery"},
    { title: "Mineral Water", image: "/img/water.jpg", link: "/tahilfoods" , brand: "Water"},
  ];

  return (
    <section id="gallery" style={{ padding: "60px 20px", backgroundColor: "#fff" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", textAlign: "center" }}>
        <h2
          style={{
            fontSize: "2.8rem",
            fontWeight: "700",
            marginBottom: "54px",
            color: "#111827",
            position: "relative",
            display: "inline-block",
          }}
        >
          Product Categories
          <span
            style={{
              content: "''",
              position: "absolute",
              width: "50%",
              height: "4px",
              backgroundColor: "#C38745",
              left: 0,
              bottom: -10,
            }}
          ></span>
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "16px",
          }}
        >
          {categories.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                sessionStorage.setItem("fromGallery", "true");
                if (item.brand) {
                  sessionStorage.setItem("activeBrand", item.brand);
                }
                navigate(`${item.link}#products`);
              }}
              style={{
                cursor: "pointer",
                background: "#f5f5f5",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                transition: "transform 0.2s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.03)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
              }}
            >
              <img
                src={item.image}
                alt={item.title}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "170px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
              <div style={{ padding: "10px", fontWeight: 600, fontSize: "2.2rem" }}>
                {item.title}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
